import { render, staticRenderFns } from "./DealModalDocuments.vue?vue&type=template&id=42f65d25&scoped=true"
import script from "./DealModalDocuments.vue?vue&type=script&lang=js"
export * from "./DealModalDocuments.vue?vue&type=script&lang=js"
import style0 from "./DealModalDocuments.vue?vue&type=style&index=0&id=42f65d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f65d25",
  null
  
)

export default component.exports